import React, {useState, useEffect} from "react";
import { ReactComponent as LocationIcon } from '../../assets/icons/location.svg';
import { ReactComponent as InstagramIcon } from '../../assets/icons/instagram.svg';
import { ReactComponent as TelegramIcon } from '../../assets/icons/telegram_bot.svg';
import { ReactComponent as MailIcon } from '../../assets/icons/mail.svg';
import { ReactComponent as LittleStarIcon } from '../../assets/icons/little-star.svg';
import s from "./socnet-block.module.scss";

const SocialNetBlock = (props) => {

    const [name, setName] = useState(props.name);

    useEffect(() => {
        setName(props.name);
    }, [props.name]);

    const getIConByName = (name) => {
        switch(name){
            case 'LOCATION':
                return <LocationIcon />
            case 'INSTAGRAM':
                return <InstagramIcon />
            case 'TELEGRAM':
            case 'TELEGRAM_2':
                return <TelegramIcon />
            case 'MAIL':
                return <MailIcon />
        }
    }

    const getTextByName = (name) => {
        switch(name){
            case 'LOCATION':
                return <div className={s.block} style={{width: '295px'}}>
                            <span className={s.titleText+" "+s.bold}>{props.getValue('NEW_REVIEW_ON_MAP')}</span>
                            <div className={s.stars}>
                                <LittleStarIcon />
                                <LittleStarIcon />
                                <LittleStarIcon />
                                <LittleStarIcon />
                                <LittleStarIcon />
                            </div>
                            <span className={s.text}>{props.getValue('GOOD_SERVICE')}</span>
                        </div>
            case 'INSTAGRAM': 
                return  <div className={s.block} style={{width: '290px'}}>
                            <span className={s.titleText+" "+s.bold}>{props.getValue('YOU_WERE_MENTIONED_IN_COMMENT')}</span>
                            <span className={s.text} style={{color: '#6C96A7'}}>{props.getValue('USER_MENTIONED_YOU')}</span>
                        </div>
            case 'TELEGRAM':   
                return <div className={s.block} style={{width: '150px'}}>
                            <span className={s.titleTextS}>ECHO ANALYTICS</span>
                            <span className={s.text}>{props.getValue('YOU_MENTIONED_ON_MEDIA')}</span>
                        </div>
            default:
                return <div className={s.block} style={{width: '205px'}}>
                            <span className={s.titleTextS}>ECHO ANALYTICS</span>
                            <span className={s.text}>{props.getValue('YOU_MENTIONED_ON_MEDIA')}</span>
                        </div>
        }
    }

    return (
        <div className={s.SocialNetBlock} style={props.styles}>
            <div className={s.SocialNet}>
                <div className={s.SocialNetIcon}>
                    { getIConByName(name) }
                </div>
                <div className={s.SocialNetContent}>
                    <div className={s.SocialNetText}>
                        { getTextByName(name) }
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SocialNetBlock;